<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component
      :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'
      @selectionchange="onSelectionChange"
      @headerselectionchange="onHeaderSelectionChange">
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-table-select-actions-form
            name="Importar"
            :baseDropDownVisible="accionesImportaciones.length > 0">
            <template slot="more">
              <span v-for="action in accionesImportaciones" :key="action.id">
                <base-button-item-list 
                  v-if="!action.onlySuperAdmin || role === 'SuperAdministrador'"
                  theme="dark" 
                  :disabled="isGeneralLoading" :loading="isGeneralLoading"
                  @click="showActionModal(action.id)">
                  <base-icon :name="action.icon" class="mr-2" :ariaHidden="true"/>
                    {{ action.name }}
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>      
      <import-xml-dialog
        :vuexNamespace="vuexnamespace"
        :activateSwitchs="false"
        :sizeLg="role !== 'Administrador'"
        :dialogOpen="showModalImportNeos"
        @toggleDialog="toggleImportNeos"
        @applyDialog="applyImportNeos"
        @downloadTemplate="downloadTemplateNeos"
        header="Importación de Notificaciones descargadas por múltiples XML" 
        />
      <import-xml-dialog
        :vuexNamespace="vuexnamespace"
        :activateSwitchs="false"
        :sizeLg="role !== 'Administrador'"
        :dialogOpen="showModalImportNeosPaD"
        @toggleDialog="toggleImportNeosPaD"
        @applyDialog="applyImportNeosPaD"
        @downloadTemplate="downloadTemplateNeosPaD"
        :maxFiles="1"
        header="Importación de Notificaciones puestas a disposición por XML" 
        />
      <import-cert-dialog
        :vuexNamespace="vuexnamespace"
        :dialogOpen="showModalImportCert" 
        @toggleDialog="toggleImportCert" 
        @applyDialog="applyImportCert"
        header="Importación de Certificados por Ficheros PFX" 
        headerValue="Contraseña de los certificados" 
        switchHeaderValue="Tipo de importación"
        switchHeaderValueActive="Certificados y empresas"
        switchHeaderValueInactive="Solo certificados"
        />
      <import-generic-dialog
        :dialogOpen="showModalImportUser"
        :vuexNamespace="vuexnamespace"
        @toggleDialog="toggleImportUser"
        @applyDialog="applyImportUser"
        @downloadTemplate="downloadTemplateUser"
        header="Importación de Usuarios" 
        />
      <import-generic-dialog
        :dialogOpen="showModalImportCertsSerial"
        :vuexNamespace="vuexnamespace"
        @toggleDialog="toggleImportCertsSerial"
        @applyDialog="applyImportCertsSerial"
        @downloadTemplate="downloadTemplateCertsSerial"
        header="Importación de Certificados por número de serie" 
        />
      <import-generic-dialog
        :vuexNamespace="vuexnamespace"
        :mandatoryClient="true"
        :activateSwitch1="true"
        :labelSwitch1="$t('app.excel_import_options_update')"
        :activateSwitch2="true"
        :labelSwitch2="$t('app.excel_import_options_update_pgns')"
        :sizeLg="role !== 'Administrador'"
        :dialogOpen="showModalImportCompany"
        @toggleDialog="toggleImportCompany"
        @applyDialog="applyImportCompany"
        @downloadTemplate="downloadTemplateCompany"
        header="Importación de Empresas" 
        />
      <import-generic-dialog
        :secondaryTemplate="true"
        :vuexNamespace="vuexnamespace"
        :activateSwitch1="true"
        :labelSwitch1="'Actualizar grupos'"
        :sizeLg="true"
        :dialogOpen="showModalImportGroup"
        @toggleDialog="toggleImportGroup"
        @applyDialog="applyImportGroup"
        @downloadTemplate="downloadTemplateGroup"
        header="Importación de Grupos" 
        />
        
      <import-generic-dialog
        :dialogOpen="showModalImportGroupingValues"
        :vuexNamespace="vuexnamespace"
        @toggleDialog="toggleImportGroupingValues"
        @applyDialog="applyImportGroupingValues"
        @downloadTemplate="downloadTemplateGroupingValues"
        header="Importación de Agrupaciones de valores" 
        />
      <import-generic-dialog
        :dialogOpen="showModalImportGroupingCompanies"
        :vuexNamespace="vuexnamespace"
        @toggleDialog="toggleImportGroupingCompanies"
        @applyDialog="applyImportGroupingCompanies"
        @downloadTemplate="downloadTemplateGroupingCompanies"
        header="Importación de Agrupaciones de empresas" 
        />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/ImportacionesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { process } from '@progress/kendo-data-query'
import { i18n } from '@/i18n'

import { getImportsPag } from '@/services/configurations/imports/getImportsPag'
import { getImportsExcel } from '@/services/configurations/imports/getImportsExcel'

import { cancelImport } from '@/services/configurations/imports/cancelImport'
import { downloadResultImport } from '@/services/configurations/imports/downloadResultImport'
import { downloadOriginImport } from '@/services/configurations/imports/downloadOriginImport'

import { TIPOS_IMPORTACION } from '@/config/tipos-importacion'

import ImportXmlDialog from '@/components/ImportXmlDialog.vue'
import { importNeos } from '@/services/configurations/imports/importNeos'
import { downloadTemplateNeos } from '@/services/configurations/imports/downloadTemplateNeos'
import { importNeosPaD } from '@/services/configurations/imports/importNeosPaD'
import { downloadTemplateNeosPaD } from '@/services/configurations/imports/downloadTemplateNeosPaD'

import ImportCertDialog from '@/components/ImportCertDialog.vue'
import { importCertificates } from '@/services/configurations/imports/importCertificates'

import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { importGroups } from '@/services/configurations/imports/importGroups'
import { downloadTemplateGroups } from '@/services/configurations/imports/downloadTemplateGroups'
import { downloadTemplateGroupsReparto } from '@/services/configurations/imports/downloadTemplateGroupsReparto'

import { importUsers } from '@/services/configurations/imports/importUsers'
import { downloadTemplateUsers } from '@/services/configurations/imports/downloadTemplateUsers'

import { importCertsSerial } from '@/services/configurations/imports/importCertsSerial'
import { downloadTemplateCertsSerial } from '@/services/configurations/imports/downloadTemplateCertsSerial'

import { importCompanies } from '@/services/configurations/imports/importCompanies'
import { downloadTemplateCompanies } from '@/services/configurations/imports/downloadTemplateCompanies'

import { importGroupingValues } from '@/services/configurations/imports/importGroupingValues'
import { downloadTemplateGroupingValues } from '@/services/configurations/imports/downloadTemplateGroupingValues'

import { importGroupingCompanies } from '@/services/configurations/imports/importGroupingCompanies'
import { downloadTemplateGroupingCompanies } from '@/services/configurations/imports/downloadTemplateGroupingCompanies'

export default {
  name: 'vista-importaciones',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    KendoGridComponent,
    CreateSearchDialog,
    ImportCertDialog,
    ImportGenericDialog,
    ImportXmlDialog,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 53,
      // Links
      isLoadedData: false,

      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,

      // Import
      showModalImportNeosPaD: false,
      showModalImportNeos: false,
      showModalImportCert: false,
      showModalImportGroup: false,
      showModalImportUser: false,
      showModalImportGroupingValues: false,
      showModalImportGroupingCompanies: false,
      showModalImportCertsSerial: false,
      showModalImportCompany: false,

      // All
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('imports.header'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'imports',
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 100, Descripcion: i18n.t('imports.cancel') },
        { IdAccion: 200, Descripcion: i18n.t('imports.download_result') },
        { IdAccion: 201, Descripcion: i18n.t('imports.download_origin') },
      ],
    }
  },
  computed: {
    empresaFilter () {
      return this.$store.getters['imports/getMasterFilters']?.empresa?.value || null
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasModuleAgrupaciones']
    },
    accionesImportaciones () {
      let res = TIPOS_IMPORTACION.filter(x => x.id !== 8 && x.id !== 9 && x.id !== 10)
      if (!this.hasModuleAgrupaciones) {
        res = res.filter(x => x.id !== 11 || x.id !== 12)
      }
      return res
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isMoreActionsVisible: function () {
      return this.getAccionesPosibles !== undefined && this.getAccionesPosibles.length > 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    selectIcon: function (action) {
      return (action) =>
        action === 100 ? 'changestatus'
          : action === 200 ? 'download'
            : action === 201 ? 'download'
              : 'trash'
    },
    getAccionesPosibles () {
      let listaAccionesFinal = this.listaAcciones.slice()
      // Al seleccionar:
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Si es más de 1 solo cancelar. No permitimos descargas más de 1
        if (this.selected.length > 1) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion === 100)
        } else {
          // Si no son todos Certificados no se puede descargar la entrada
          if (this.selected.length === this.selected.filter(x => x.idTipo === 1 || x.idTipo === 6 || x.idTipo === 7).length) {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 201)
          }
          // Si hay alguno procesando, no se puede descargar el resultado
          if (this.selected.filter(x => x.idEstado === 0).length > 0) {
            listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 200)
          }
        } 
        // Si no son todos en Error no se puede cancelar
        if (this.selected.length !== this.selected.filter(x => x.idEstado === 2).length) {
          listaAccionesFinal = listaAccionesFinal.filter(x => x.IdAccion !== 100)
        }
      }
      return listaAccionesFinal
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
    },
    headerCoreFilters: {
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    },
  },
  created: async function () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    toggleImportCompany () {
      this.showModalImportCompany = !this.showModalImportCompany
    },
    toggleImportUser () {
      this.showModalImportUser = !this.showModalImportUser
    },
    toggleImportGroupingValues () {
      this.showModalImportGroupingValues = !this.showModalImportGroupingValues
    },
    toggleImportGroupingCompanies () {
      this.showModalImportGroupingCompanies = !this.showModalImportGroupingCompanies
    },
    toggleImportCertsSerial () {
      this.showModalImportCertsSerial = !this.showModalImportCertsSerial
    },
    toggleImportNeos () {
      this.showModalImportNeos = !this.showModalImportNeos
    },
    toggleImportNeosPaD () {
      this.showModalImportNeosPaD = !this.showModalImportNeosPaD
    },
    toggleImportGroup () {
      this.showModalImportGroup = !this.showModalImportGroup
    },
    toggleImportCert () {
      this.showModalImportCert = !this.showModalImportCert
    },
    applyGenericImport: async function (file, form, importFunction, toggleFunction) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importFunction(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          toggleFunction() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportCompany: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { 
          idCliente: form.idCliente,
          actualizarCIFS: form.switch1,
          vincularSedes: form.switch2,
        }
        const response = await importCompanies(file, params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportCompany() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportNeos: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const xmls = await this.filesToPayloadXML(files)
        const payload = {
          idCliente: form.idCliente,
          AplicarReglas: form.switch1,
          Notificaciones: xmls,
        }

        const response = await importNeos(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportNeos() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportNeosPaD: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const xmls = await this.filesToPayloadXML(files)

        const payload = {
          idCliente: form.idCliente,
          Notificaciones: xmls[0],
        }

        const response = await importNeosPaD(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportNeosPaD() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportUser: async function (file, form) {
      this.applyGenericImport(file, form, importUsers, this.toggleImportUser)
    },
    applyImportGroupingValues: async function (file, form) {
      this.applyGenericImport(file, form, importGroupingValues, this.toggleImportGroupingValues)
    },
    applyImportGroupingCompanies: async function (file, form) {
      this.applyGenericImport(file, form, importGroupingCompanies, this.toggleImportGroupingCompanies)
    },
    applyImportCertsSerial: async function (file, form) {
      this.applyGenericImport(file, form, importCertsSerial, this.toggleImportCertsSerial)
    },
    applyImportGroup: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importGroups(file, { idCliente: form.idCliente, actualizarGrupos: form.switch1 })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportGroup() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportCert: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const certificados = []
        const listPromises = []
        // Ejemplo promesas multiples asincronas con espera final de todas
        files.forEach((file) => {
          listPromises.push(this.getBase64(file.raw)
            .then(res => {
              const b64 = res.split(',')[1]
              certificados.push({
                Base64: b64,
                Nombre: file.name
              })
            }))
        })
        await Promise.all(listPromises)
        const payload = {
          idCliente: form.idCliente,
          Password: form.value,
          VincularEmpresas: form.switch,
          Certificados: certificados,
        }
        const response = await importCertificates(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportCert() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateGeneric: async function (downloadFunction, nameFile = 'plantilla.xlsx') {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadFunction()
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, nameFile)
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateCompany: async function (formIdCliente) {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idCliente: formIdCliente
        }
        const response = await downloadTemplateCompanies(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-empresas.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateNeos: async function () { 
      this.downloadTemplateGeneric(downloadTemplateNeos, 'importacion-neos-desc-xsd-ejemplos.zip')
    },
    downloadTemplateNeosPaD: async function () { 
      this.downloadTemplateGeneric(downloadTemplateNeosPaD, 'importacion-neos-pad-xsd-ejemplos.zip')
    },
    downloadTemplateUser: async function () {
      this.downloadTemplateGeneric(downloadTemplateUsers, 'plantilla-importacion-usuarios.xlsx')
    },
    downloadTemplateGroupingValues: async function () {
      this.downloadTemplateGeneric(downloadTemplateGroupingValues, 'plantilla-importacion-agrupaciones-valores.xlsx')
    },
    downloadTemplateGroupingCompanies: async function () {
      this.downloadTemplateGeneric(downloadTemplateGroupingCompanies, 'plantilla-importacion-agrupaciones-empresas.xlsx')
    },
    downloadTemplateCertsSerial: async function () {
      this.downloadTemplateGeneric(downloadTemplateCertsSerial, 'plantilla-importacion-certificados-serial.xlsx')
    },
    downloadTemplateGroup: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateGroups()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-grupos-gestion.xlsx')
        }
        const responseReparto = await downloadTemplateGroupsReparto()
        if (responseReparto.blnError === true) {
          this.doFeedback(responseReparto.msgError + ' [Código de error: ' + responseReparto.codError + ']')
        } else {
          this.downloadBlob(responseReparto, 'plantilla-importacion-grupos-reparto.xlsx')
        }
      } catch (error) {
        console.error(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          // Mantenemos filtro de cliente
          const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
          if (data.empresa) filters.empresa = { label: data.empresa.label, value: data.empresa.value } 
          if (filter.type === 'tipoImportacionEstado') {
            filters.tipoImportacionEstado = { label: this.$i18n.t('imports.status'), value: filter.data }
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)      
      // Fix temporal para mostrar columnas después de reordenar
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
      // Old sin fix
      // this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        fechaDesde: data.fechaDesde ? data.fechaDesde.value : null,
        fechaHasta: data.fechaHasta ? data.fechaHasta.value : null,
        tipoImportacion: data.tipoImportacion ? data.tipoImportacion.value : null,
        tipoImportacionEstado: data.tipoImportacionEstado ? data.tipoImportacionEstado.value : null,
        empresa: data.empresa ? data.empresa.value : null,
        distribuidor: data.distribuidor ? data.distribuidor.value : null,
        usuario: data.usuario ? data.usuario.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
        const payload = { order: objOrder.order, grupos: objColumnas }
        if (this.hasSelected) {
          const selectedIDs = this.selected.map(x => x.idImportacion)
          payload.listaIDs = selectedIDs
        }
        const response = await getImportsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'importaciones.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    updateOnRouteChange: async function (to, from) {
      this.filterByParamsData()
      await this.applyFilters()
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        fechaDesde: data.fechaDesde ? data.fechaDesde.value : null,
        fechaHasta: data.fechaHasta ? data.fechaHasta.value : null,
        tipoImportacion: data.tipoImportacion ? data.tipoImportacion.value : null,
        tipoImportacionEstado: data.tipoImportacionEstado ? data.tipoImportacionEstado.value : null,
        empresa: data.empresa ? data.empresa.value : null,
        distribuidor: data.distribuidor ? data.distribuidor.value : null,
        usuario: data.usuario ? data.usuario.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getImportsPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 100) { 
        this.cancelImport()
      } else if (this.selectedAction.IdAccion === 201) { 
        this.downloadExcelHandler(downloadOriginImport)
      } else if (this.selectedAction.IdAccion === 200) { 
        this.downloadExcelHandler(downloadResultImport)
      } else {
        console.error('Acción desconocida')
      }
    },
    showActionModal: function (idAccion) {
      if (idAccion === 1) { 
        this.toggleImportCert()
      } else if (idAccion === 2) {
        this.toggleImportGroup()
      } else if (idAccion === 3) {
        this.toggleImportUser()
      } else if (idAccion === 4) {
        this.toggleImportCompany()
      } else if (idAccion === 5) {
        this.toggleImportCertsSerial() 
      } else if (idAccion === 6) {
        this.toggleImportNeos() 
      } else if (idAccion === 7) {
        this.toggleImportNeosPaD() 
      } else if (idAccion === 11) {
        this.toggleImportGroupingValues() 
      } else if (idAccion === 12) {
        this.toggleImportGroupingCompanies() 
      } else {
        console.log('Acción desconocida')
      }
    },
    filesToPayloadXML: async function (files) {
      const xmls = []
      const listPromises = []
      // Ejemplo promesas multiples asincronas con espera final de todas
      files.forEach((file) => {
        listPromises.push(this.getBase64(file.raw)
          .then(res => {
            const b64 = res.split(',')[1]
            xmls.push({
              Base64: b64,
              Nombre: file.name
            })
          }))
      })
      await Promise.all(listPromises)
      return xmls
    },
    cancelImport: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.idImportacion)
        }
        const response = await cancelImport(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    downloadExcelHandler: async function (apiCall) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await apiCall({ idImportacion: this.selected[0].idImportacion })
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = response.headers.filename
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.log(error)
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
